/* GL3d: bundelbouwer (eigen code). Stappen: grootte kiezen, tassen kiezen, in de wagen. Maximaal 5 stuks per bestelling. */
(function () {
  document.querySelectorAll('[data-mbd-bundle]').forEach(function (root) {
    var MAX = parseInt(root.dataset.max, 10) || 5, CUR = root.dataset.currency || 'AUD';
    var S = { size: 0, items: [], cache: {}, tab: null, shown: 12 };
    var q = function (s) { return root.querySelector(s); };
    function money(v) { var n = parseFloat(v || 0); if (!n) return 'FREE'; try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: CUR }).format(n); } catch (e) { return n.toFixed(2); } }
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function msg(t) { var m = q('[data-msg]'); m.textContent = t || ''; }
    function update() {
      var n = S.items.length, t = S.size;
      q('[data-count]').innerHTML = t ? '<b>' + n + '</b> of ' + t + ' bags selected' : 'Choose your bundle size to begin';
      q('[data-fill]').style.width = t ? Math.min(100, Math.round(n / t * 100)) + '%' : '0';
      var go = q('[data-go]'), ready = t && n === t;
      go.disabled = !ready; go.classList.toggle('is-ready', !!ready);
      go.textContent = ready ? 'Add my ' + t + ' bags to the cart' : (t ? 'Add ' + (t - n) + ' more' : 'Claim My Bundle');
    }
    root.querySelectorAll('[data-n]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.size = parseInt(b.dataset.n, 10);
        if (S.items.length > S.size) S.items = S.items.slice(0, S.size);
        root.querySelectorAll('[data-n]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        q('[data-step2]').hidden = false; msg('');
        if (!S.tab) { var f = q('[data-tabs] button'); if (f) selectTab(f); }
        update(); q('[data-step2]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    function selectTab(b) {
      S.tab = b.dataset.handle; S.shown = 12;
      root.querySelectorAll('[data-tabs] button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      load();
    }
    q('[data-tabs]').addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) selectTab(b); });
    function load() {
      var h = S.tab, g = q('[data-grid]');
      if (S.cache[h]) return paint();
      g.innerHTML = '<div class="mbd-b__empty">Loading...</div>';
      fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250').then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) { S.cache[h] = (d.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }); paint(); })
        .catch(function () { g.innerHTML = '<div class="mbd-b__empty">Could not load this collection. Please try another tab.</div>'; });
    }
    function paint() {
      var g = q('[data-grid]'), list = S.cache[S.tab] || [];
      if (!list.length) { g.innerHTML = '<div class="mbd-b__empty">No bags available here right now.</div>'; q('[data-more]').hidden = true; return; }
      g.innerHTML = '';
      list.slice(0, S.shown).forEach(function (p) { g.appendChild(card(p)); });
      q('[data-more]').hidden = list.length <= S.shown;
    }
    q('[data-more]').addEventListener('click', function () { S.shown += 12; paint(); });
    function card(p) {
      var vars = p.variants.filter(function (v) { return v.available; }), picked = S.items.some(function (i) { return i.pid === p.id; });
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var c = document.createElement('div'); c.className = 'mbd-b__card' + (picked ? ' is-picked' : '');
      var sel = vars.length > 1 ? '<select aria-label="Size">' + vars.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '';
      c.innerHTML = (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '<div class="mbd-b__body"><div class="mbd-b__ttl">' + esc(p.title) + '</div><div class="mbd-b__price">' + money(vars[0].price) + '</div>' + sel + '<button type="button" class="mbd-b__add">' + (picked ? 'Added' : 'Add to bundle') + '</button></div>';
      c.querySelector('.mbd-b__add').addEventListener('click', function () {
        if (picked) { S.items = S.items.filter(function (i) { return i.pid !== p.id; }); update(); paint(); return; }
        if (!S.size) { msg('Choose your bundle size first.'); return; }
        if (S.items.length >= S.size) { msg('Your bundle is full. Remove one to swap.'); return; }
        var se = c.querySelector('select'), vid = se ? +se.value : vars[0].id;
        S.items.push({ pid: p.id, vid: vid }); msg(''); update(); paint();
      });
      return c;
    }
    q('[data-go]').addEventListener('click', function () {
      if (!S.size || S.items.length !== S.size) return;
      var go = q('[data-go]'); go.disabled = true; go.textContent = 'Adding...';
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if ((cart.item_count || 0) + S.items.length > MAX) { msg('Your cart already holds ' + cart.item_count + ' bag(s). You can order up to ' + MAX + ' bags per order.'); update(); return; }
        var items = {}; S.items.forEach(function (i) { items[i.vid] = (items[i.vid] || 0) + 1; });
        var list = Object.keys(items).map(function (k) { return { id: +k, quantity: items[k] }; });
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { if (!r.ok) throw 0; window.location.href = '/cart'; });
      }).catch(function () { msg('Something went wrong. Please try again.'); update(); });
    });
    update();
  });
})();
